var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"tag":"a","href":_vm.loginUrl,"target":"_self","type":"secondary","full-width":"","size":"large"}},[_c('AuthProviderIcon',{attrs:{"icon":_vm.icon}}),_vm._v(" "),(!_vm.small)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('loginButton.continueWith'))+" "+_vm._s(_vm.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }